import { FunctionariesSwitchHistorical } from '../../../../../shared/types/systemConfiguration/functionariesSwitch';

export interface FunctionariesSwitchHistoricalProps {
    historical: FunctionariesSwitchHistorical[];
    showHistorical?: boolean;
}

export const functionariesFieldEquivalences: { [key: string]: string } = {
    created_at: 'Fecha de creación',
    updated_at: 'Fecha de última modificación',
    name: 'Nombre',
    surname: 'Apellido',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    extension: 'Extensión',
    active: 'Activo',
    area: 'Área',
    position: 'Cargo',
    createdBy: 'Creado por',
    updatedBy: 'Última modificación por',
};
